import Vue from 'vue';
import { mapActions } from 'vuex';
import GalleryView from '@/components/GalleryView.vue';
import FormView from '@/components/FormView.vue';
import AudioPlayer from '@/components/AudioPlayer.vue';
import AccordionView from '@/components/AccordionView.vue';
import SubscriptionView from '@/components/SubscriptionView.vue';
import GmapView from '@/components/GmapView.vue';
import PageView from '@/views/PageView.vue';
import StampItem from '@/components/StampItem.vue';
import LogoItem from '@/components/LogoItem.vue';
import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';
import featureSetMixin from '@/store/modules/featureSet/feature-set-loader';
import * as parserRegexes from './content-parser-regexes';

let privateCustomClasses = [];

export default {
	mixins: [staticDataLoaderMixin, contentDataLoaderMixin, featureSetMixin],
	data() {
		return {
			pageTitle: '',
			pageBody: '',
			containerClass: 'default-container',
			contentClass: 'default-content',
			customClasses: '',
		};
	},
	props: {
		noTitle: {
			type: Boolean,
			default: false,
		},
		noTitleUpdate: {
			type: Boolean,
			default: false,
		},
	},
	created() {
		// this.reparseAll();
	},
	render(createElement) {
		privateCustomClasses = [];
		this.reparseAll();
		this.customClasses = privateCustomClasses.join(' ');

		const finalView = Vue.component('final-view', {
			template: this.pageBody,
			components: {
				'gallery-view': GalleryView,
				'form-view': FormView,
				'audio-player': AudioPlayer,
				'accordion-view': AccordionView,
				'subscription-view': SubscriptionView,
				'gmap-view': GmapView,
				'page-view': PageView,
				'stamp-item': StampItem,
				'logo-item': LogoItem,
			},
		});

		return createElement('div', { class: { [this.containerClass]: true, [this.customClasses]: true } }, [createElement(finalView)]);
	},
	methods: {
		// ...mapActions('gallery', ['setGid']),
		...mapActions('title', ['setTitle']),
		parseBody(body) {
			// galleries
			let newBody = body;
			if (parserRegexes.galleryRegex.test(body)) {
				newBody = body.replace(parserRegexes.galleryRegex, (...args) => {
					const gid = args[2];
					// this.setGid(Number(gid));
					return `<gallery-view gid="${gid}" />`;
				});
			} else {
				// this.setGid('');
			}
			// pages
			if (parserRegexes.pageRegex.test(body)) {
				newBody = newBody.replace(parserRegexes.pageRegex, (...args) => (args[2] ? `<page-view id="${args[2]}" class="${args[4]}" no-title noBackground></page-view>` : ''));
			}
			// action links
			newBody = newBody.replace(parserRegexes.actionRegex, (...args) => {
				const url = args[2];
				const text = args[4];
				return `<a href="${url}" class="content-parser-action-link">${text}</a>`;
			});
			newBody = newBody.replace(parserRegexes.imageTextRegex, (...args) => {
				const type = args[2];
				const imageId = args[4];
				const { name, finalUrl } = this.getMediaAndParse(imageId);
				const text = args[6];
				return `<div class="image-text-${type}">
							<img src="${finalUrl}" title="${name}">
							<span>${text}</span>
						</div>`;
			});
			// gmap
			newBody = newBody.replace(parserRegexes.gmapRegex, (...args) => `<gmap-view gmapiframe='${args[2]}' />`);
			// subscription
			newBody = newBody.replace(parserRegexes.subscriptionRegex, '<subscription-view />');
			// youtube
			newBody = newBody.replace(parserRegexes.youtubeRegex, '<iframe src="https://www.youtube-nocookie.com/embed/$2?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
			// forms
			newBody = newBody.replace(parserRegexes.formRegex, '<form-view fid="$2" />');
			// accordion
			newBody = newBody.replace(parserRegexes.accordionRegex, '<accordion-view accid="$2" />');
			// image link
			newBody = newBody.replace(parserRegexes.anchorRegex, (...args) => {
				const data = args[0].split('-:-');
				const splitForId = data[0].split(':');
				const foundId = parseInt(splitForId[splitForId.length - 1], 10);
				const { name, finalUrl } = this.getMediaAndParse(foundId);
				return `<a href="${data[1].slice(0, -1)}" target="_blank" class="content-parser-anchor-image"><img src="${finalUrl}" title="${name}"/></a>`;
			});
			// media files (images)
			newBody = newBody.replace(parserRegexes.mediaRegex, (...args) => {
				const foundId = parseInt(args[2], 10);
				const { name, finalUrl } = this.getMediaAndParse(foundId);
				if (this.featureSet.contentParser.imagesAsCSS) {
					return `<div class="content-parser-image cpi-as-css" style="background-image: url('${finalUrl}')"></div>`;
				}

				return `<div class="content-parser-image"><img src="${finalUrl}" title="${name}"/></div>`;
			});
			// links to media content
			newBody = newBody.replace(parserRegexes.linkRegex, (...args) => {
				const foundId = parseInt(args[2], 10);
				const { filename, name, finalUrl } = this.getMediaAndParse(foundId);

				const docRegex = /(\.pdf$)|(\.doc$)|(\.docx$)|(\.xls$)|(\.xlsx$)/gmi;
				const archRegex = /(\.zip$)|(\.rar$)|(\.7z$)/gmi;
				let innerContent = '';
				let icon = '';
				if (docRegex.test(filename)) {
					icon = 'file-alt';
				} else if (archRegex.test(filename)) {
					icon = 'file-archive';
				} else {
					icon = 'download';
				}
				innerContent = `<fa-icon icon="${icon}" />`;
				return `<a class="content-parser-link ${icon}" href="${finalUrl}" target="_blank">${innerContent}${name}</a>`;
			});
			// audio player
			newBody = newBody.replace(parserRegexes.audioRegex, '<audio-player id="$2" />');

			// check if any galleries were found
			if (new RegExp('<gallery-view', 'gmi').test(newBody)) {
				privateCustomClasses.push('full-width');
			}

			newBody = newBody.replace(parserRegexes.ccLogoRegex, '<logo-item type="$2"></logo-item>');
			newBody = newBody.replace(parserRegexes.stampRegex, '<stamp-item type="$2" original></stamp-item>');

			// check if any columns and clean the paragraphs around it
			const bodyArray = newBody.split('[COL]');
			const numberOfColumns = bodyArray.length;
			if (numberOfColumns > 1) {
				let splitColsBody = '';
				bodyArray.forEach((element) => {
					let cleanPart = element.trim();
					while (cleanPart.startsWith('</p>')) {
						cleanPart = cleanPart.substring(4, cleanPart.length);
					}
					while (cleanPart.endsWith('<p>')) {
						cleanPart = cleanPart.substring(0, cleanPart.length - 3);
					}

					const classes = ['content-parser-column'];
					if (cleanPart.indexOf('iframe') >= 0) {
						// youtube video columns must have a 100% width
						classes.push('content-parser-column-full-width');
					}
					if (cleanPart.length > 10) {
						// don't add too short columns to allow for the empty first column hack
						splitColsBody += `<div class="${classes.join(' ')}">${cleanPart}</div>`;
					}
				});
				newBody = splitColsBody;
			}

			return newBody;
		},
		reparseAll() {
			const tempPageTitle = this.getContentById(this.contentType, this.pid).title;
			this.pageTitle = typeof tempPageTitle === 'string' ? JSON.parse(tempPageTitle)[this.language] : tempPageTitle[this.language];

			let tempPageBody = this.getContentById(this.contentType, this.pid).body;
			tempPageBody = typeof tempPageBody === 'string' ? JSON.parse(tempPageBody)[this.language] : tempPageBody[this.language];
			tempPageBody = this.parseBody(tempPageBody);

			// special features
			let tempHeaderImage = '';
			if (this.featureSet.contentParser.imageAsHeader) {
				const headerImage = this.getMediaAndParse(this.getContentById(this.contentType, this.pid).file_id);
				if (headerImage.finalUrl !== '#') {
					tempHeaderImage = `<div class="${this.contentClass}-header-image"><img src="${headerImage.finalUrl}"></div>`;
				}
			}

			// assemble the body
			let fullPageBodyString = '';
			if (tempHeaderImage) {
				fullPageBodyString = `<div class="${this.contentClass} alt-view">${tempHeaderImage}`;
			} else {
				fullPageBodyString = `<div class="${this.contentClass}">`;
			}
			if (this.featureSet.pagesView.titleDecoration) {
				if (!this.noTitle) fullPageBodyString += `<div class="title-container"><img class="title-decoration" src="/storage/static/LAsset.png"/><h1 href="#pageTitle">${this.pageTitle}</h1><img class="title-decoration" src="/storage/static/RAsset.png"/></div>`;
			} else if (!this.noTitle) fullPageBodyString += `<h1 href="#pageTitle">${this.pageTitle}</h1>`;
			fullPageBodyString += `${tempPageBody}</div>`;

			// get the category name if content type is 'posts'
			if (this.contentType === 'posts') {
				const category = this.categories.find(c => c.id === Number(this.getContentById(this.contentType, this.pid).category_id));
				privateCustomClasses.push(`post-view-${category.view}`);
			}

			// final assignment to avoid the infinite render loop
			this.pageBody = fullPageBodyString;
			if (!this.noTitleUpdate) {
				this.setTitle(`${this.pageTitle} - ${this.$store.state.cName}`);
			}
		},
		getMediaAndParse(id) {
			const mItem = this.getContentById('media', id);
			if (!mItem) {
				return {
					filename: 'N/A',
					name: 'N/A',
					finalUrl: '#',
				};
			}
			const filename = mItem.original_name;
			const name = JSON.parse(mItem.name)[this.language];
			const finalUrl = `/storage/media/${filename}`;
			return { filename, name, finalUrl };
		},
	},
};
